import {AfterViewInit, Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {AuthService, ConfigurationService, DataClientError, LoginType} from "@fedeltapointofsale/data-client";
import {ErrorHandlerService} from "../../error-handler.service";
import {AnalyticsService} from "../../analytics/analytics.service";
import {AnalyticEvent} from "../../analytics/analytic-event";
import {FUIAlertService} from "@fedeltapointofsale/ui";
import {NgForm} from "@angular/forms";
import {Config} from "../../config";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: "wbo-login-page",
    templateUrl: "./login-page.component.html",
    styleUrls: ["./login-page.component.scss"]
})
export class LoginPageComponent implements OnInit, AfterViewInit {

    public active: boolean = true;
    public username: string;
    public password: string;
    public remember: boolean;

    constructor(private router: Router,
                private errorHandlerService: ErrorHandlerService,
                private authService: AuthService,
                private configService: ConfigurationService,
                private analyticsService: AnalyticsService,
                private alertService: FUIAlertService,
                private httpClient: HttpClient) {
    }

    async ngOnInit(): Promise<void> {
        if (this.authService.isLoggedIn()) {
            this.loggedIn();
        }
    }

    ngAfterViewInit(): void {
        // Workaround issue of video not playing if routed here from the auth guard
        const vid: HTMLVideoElement = document.getElementsByTagName("video").item(0);
        vid.muted = true;
        vid.play();
    }

    /**
     *
     */
    login(form: NgForm) {
        if (!form.valid) {
            this.alertService.showError(undefined, "wbo.login.prompt.loginError.message").subscribe(() => {
            });
            return;
        }
        if (this.username && this.password) {
            this.authService.login(this.username, this.password, LoginType.USER, {remember: this.remember === true}).subscribe({
                next: (success: boolean) => {
                    if (success) {
                        this.analyticsService.trackEvent(AnalyticEvent.USER_LOGIN);
                        this.loggedIn();
                    } else {
                        this.errorHandlerService.displayError("wbo.login.error.failed");
                    }
                },
                error: async (error: DataClientError) => {
                    this.resetForm();
                    const displayableMessage = await error.displayableMessage;
                    if (error.status === 401 && displayableMessage) {
                        this.errorHandlerService.displayError(displayableMessage.messageKey, displayableMessage.messageParams);
                    } else if (error.status === 404) {
                        this.errorHandlerService.displayError("wbo.common.error.noService");
                    } else {
                        this.errorHandlerService.displayError("wbo.common.error.noConnection");
                    }
                }
            });
        }
    }

    /**
     *
     */
    resetForm(): void {
        this.username = null;
        this.password = null;
        this.remember = false;
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    loggedIn(): void {
        this.configService.setContext("userId", this.authService.getLoggedInUserId().toString());
        this.configService.setContext("role", this.authService.getLoggedInRole());
        this.configService.getBoolean(Config.BACKOFFICE_USER_REQUEST_PROFILE_COMPLETION).then((enabled: boolean) => {
            if (enabled) {
                this.router.navigate(["/profile-completion"]);
            } else {
                this.router.navigate([""]);
            }
        });
    }
}
